function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

$( document ).ready(function() {
  $('.nav_mega_menus > ul > li').each(function(e){
	  var link_id = $(this).attr('data-link-id');
    var clone_menu = $('.mega-menu[data-meganav-handle="'+link_id+'"]').clone();
    $(this).append(clone_menu);
  });
  $('.y-menu--level-1--container .y-menu--level-1--link').each(function(e){
	  var link_id = $(this).attr('data-link-id');
    var clone_menu = $('.mobile-meganav-source[data-mobile-meganav-handle="'+link_id+'"]').html();
    if(clone_menu != '' && clone_menu != undefined){
    $(this).find('.y_link').addClass('have_submenu');
    $(this).find('.y_link').append('<svg class="icon--root icon--chevron-right--small" width="8" height="14" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg"><path d="M6.274 7.202.408 1.336l.707-.707 6.573 6.573-.096.096-6.573 6.573-.707-.707 5.962-5.962Z" fill="#000" fill-rule="nonzero"></path></svg>')
    $(this).append(clone_menu);
    }
  });
  $('.nav_mega_menus > ul > li').hover(function(e){
    $('.mega-menu').hide();
    $(this).find('.mega-menu').show();
  }); 
  $('.bar_close').click(function(e){
    $(this).parent('.announcement--root').slideUp();
  });  
  $('.layout--login .login_inner').click(function(e){
    $(this).parent('.layout--login').siblings('.account_details_dropdown').toggleClass('active');
  });
  // Start Customer Data Update
  $('#customer_image').change(function(){
    const file = this.files[0];
    if (file){
      let reader = new FileReader();
      reader.onload = function(event){
        // console.log(event.target.result);
        $('#imgPreview').attr('src', event.target.result);
      }
      reader.readAsDataURL(file);
      $(this).siblings('label').html('Change Profile Image')
    }
  });
  $('#custom_customer').submit(function(e){
    e.preventDefault();
    // return false;
    console.log(getCookie('_secure_session_id'));
    var ImageURL = $('#imgPreview').attr('src'),
        this_btn = $(this),
        data = new FormData($('#custom_customer').get(0));
        data.append("upload_image", ImageURL);
        // console.log(ImageURL);
        // console.log(data);
        $('span.page__spinner').css('display','flex');
    // return;
    $.ajax({
        data: data,
        url: "https://api-dev.unwritten.hair/api/shopify/customer/",
        type: "POST",
        processData: false,
        contentType: false,
        success: function (data) {
          var Data = data;
          console.log(Data);
          if(Data.data.errors != '' && Data.data.errors != undefined && Data.data.errors != null){
            if(Data.data.errors.phone[0] != ''){
            alert(Data.data.errors.phone[0]);
            }else{
              alert(Data.data.errors);
            }
            $('span.page__spinner').css('display','none');
          }else{
            console.log(Data);
            if(Data.status.message == 'User Profile updated successfully.' || Data.status.message  == 'Profile updated successfully'){
              window.location.href = '/account';
            }
          }
          $('span.page__spinner').css('display','none');
        },
        error: function (data) {
          var Data = $.parseJSON(data.responseText);
          console.log('error_log',Data);
          if(Data.error != '' && Data.error != undefined && Data.error != null){
            alert(Data.error);
            $('span.page__spinner').css('display','none');
          }else{
            console.log(Data);
          }
          $('span.page__spinner').css('display','none');
        }
    });
  });
  // End Customer Data Update
});
$(document).mouseover(function(e){
  var container = $(".nav_mega_menus");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.mega-menu').hide();
  }
});
$(document).on('click', '.y_link.have_submenu', e => {
  e.preventDefault();
  const $this = $(e.currentTarget);
  const $sibling = $this.siblings('ul');
  const height = $sibling.height();
  $('y-menu-root.y-menu').height(height);
  $sibling.css('transform','translateX(-100%)');
  $('.off-canvas--container .mobile-nav--footer').hide();
});
$(document).on('click', '.y-menu--back-link_mega', e => {
  e.preventDefault();
  const $this = $(e.currentTarget);
  const $parent = $this.parent('.y-menu--level-2--container');
  const height = $('.y-menu--level-1--container').height();
  $('y-menu-root.y-menu').height(height);
  $parent.css('transform','translateX(0)');
  $('.off-canvas--container .mobile-nav--footer').show();
});
$(document).on('click', '.y-menu--back-link_mega_2', e => {
  e.preventDefault();
  const $this = $(e.currentTarget);
  const $parent = $this.parent('.y-menu--level-3--container');
  const $parent2 = $this.closest('.y-menu--level-2--container');
  $parent.css('transform','translateX(0)');
  $parent2.css('transform','translateX(-100%)');
  const height = $this.closest('.y-menu--level-2--container').height();
  $('y-menu-root.y-menu').height(height);
});


$(document).on('click', '.js-change-quantity', e => {
  const $this = $(e.currentTarget);
  const $input = $this.siblings('input');
  const val = parseInt($input.val(), 10);
  let valMax = 100000000000000000000000000000;
  const valMin = $input.attr('min') || 0;
  if ($input.attr('max') != null) {
    valMax = $input.attr('max');
  }
  if (isNaN(val) || val < valMin) {
    $input.val(valMin);
  } if (val > valMax) {
    $input.val(valMax);
  }
  if ($this.data('func') === 'plus') {
    if (val < valMax) $input.val(val + 1);
  } else {
    if (val > valMin) $input.val(val - 1);
  }
  $input.trigger('change');
});

$(document).on('click', '.order_item_toggle .icons', e => {
  const $this = $(e.currentTarget).parent();
  $this.toggleClass('active');
  $this.siblings('.order_item_toggle_content').slideToggle();
});
$(document).on('click', '.order_tracking_toggle', e => {
  const $this = $(e.currentTarget);
  $this.toggleClass('active');
  $this.siblings('.order_tracking_content').slideToggle();
});

//target_blank
$( document ).ready(function() {
    $(".insta-sec a, [data-link-id=professional] a")
    .filter(function () {
        return this.hostname != window.location.hostname;
    })
    .attr("target", "_blank");
});     

//menu #
$( document ).ready(function() {
    $('a.y_link.have_submenu[href="#"]')
    .removeAttr("href");
}); 

//remove duplicate items / cart
$( document ).ready(function() {
  var elem = {};
  $('[data-view=mobile] .cart--item').each(function() {
     var txt = $(this).attr('data-variant-id');
     if (elem[txt])
         $(this).remove();
     else
         elem[txt] = true;
  });
}); 